import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import propTypes from '../../../node_modules/prop-types/index.js';
import { safeRest, noop } from '../../utils/functions.js';
import handle from '../../utils/handle.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { RadioWrapper } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var _excluded = ["id", "name", "disabled", "error", "customStyle", "onChange"];
var RadioButton = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      name = _ref.name,
      disabled = _ref.disabled,
      error = _ref.error,
      customStyle = _ref.customStyle,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var safeProps = safeRest(rest);

  var _safeCustomStyle = safeCustomStyle(customStyle),
      radioStyle = _safeCustomStyle.radioStyle;

  return /*#__PURE__*/React.createElement(RadioWrapper, _extends({}, safeProps, {
    id: id,
    type: "radio",
    name: name,
    disabled: disabled,
    error: error,
    onChange: handle(onChange),
    radioStyle: radioStyle,
    theme: theme,
    ref: ref
  }));
});
process.env.NODE_ENV !== "production" ? RadioButton.propTypes = {
  /** ID for the radiobutton */
  id: propTypes.string.isRequired,

  /** name for the radiobutton */
  name: propTypes.string,

  /** Disable the radiobutton */
  disabled: propTypes.bool,

  /** Show error state for radio button */
  error: propTypes.bool,

  /** Callback to be called when the checkbox changes */
  onChange: propTypes.func,

  /** Style overrides */
  customStyle: propTypes.shape({
    radioStyle: propTypes.object
  })
} : void 0;
RadioButton.defaultProps = {
  name: '',
  disabled: false,
  error: false,
  onChange: noop,
  customStyle: {
    radioStyle: {}
  }
};
process.env.NODE_ENV !== "production" ? RadioButton.displayName = 'RadioButton' : void 0;

export default RadioButton;
